import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// loop over all rules
Object.keys(rules).forEach((key) => {
    extend(key, {
        ...rules[key], // add the rule
        message: en.messages[key], // add its message
    });
});
